<template>
  <SkeletonBlock
    :is-active="isSkeletonActive"
    :width="95"
    :height="48"
  >
    <slot />
  </SkeletonBlock>
</template>

<script setup lang="ts">
  import { SkeletonBlock } from '@experience/core-skeleton-lib';
  import { useListingSkeleton } from '@/shared/composables/useDelayedListingSkeleton.ts';

  const { isSkeletonActive } = useListingSkeleton();
</script>

<style lang="scss"></style>
